import React, { useEffect, useState } from 'react'
import { Form, Modal, Select, TreeSelect } from 'antd'
import { exportHolidayV2, holidayDataName } from 'api/Admin/holiday'
import { getFileSecurityFromApi } from 'api/OpenFile'

const ExportHolidayModal = (props) => {
  const { SHOW_PARENT } = TreeSelect
  // const { TreeNode } = TreeSelect
  const { visible, setVisible, dataTree, parent_ID, token } = props
  const [formHolidayExport] = Form.useForm()
  const [listcompanysearch, setListCompanySearch] = useState([])
  const [listopersearch, setListOperSearch] = useState([])
  const [listsubsearch, setListSubSearch] = useState([])
  const [listHoliday, setListHoliday] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [unlockBtnExport, setUnlockBtnExport] = useState(true)
  const [treeHoliday, setTreeHoliday] = useState([])
  // console.log('exp', parent_ID, 'visible', visible)

  useEffect(async () => {
    if (dataTree?.length !== 0 && dataTree !== undefined && visible === true) {
      const dataCompanySetup = dataTree.map((c) => {
        return {
          key: c.id,
          value: c.id,
          label: c.title,
        }
      })
      const findCompanyDefaultMatch = dataTree.find((f) => f.id === parent_ID)
      setListCompanySearch(dataCompanySetup)
      formHolidayExport.setFieldsValue({
        company: findCompanyDefaultMatch?.id || null,
      })
      onChangeEvent(findCompanyDefaultMatch?.id, 'company')
      fetchListHoliday({ company_id: findCompanyDefaultMatch?.id || null })
    }
  }, [dataTree, visible])

  const fetchListHoliday = async (form) => {
    const search = {
      ...form,
    }
    // console.log('search', search)
    try {
      await holidayDataName({
        params: search,
        token: token,
      }).then((res) => {
        const { status, data } = res
        if (status === 200) {
          const optionsTreeNode = data?.map((h, idx) => {
            return {
              value: h.name,
              title: h.name,
              key: `0-0-${idx}`,
            }
          })
          setListHoliday(optionsTreeNode)
          setTreeHoliday([
            {
              title: 'All Holiday',
              value: 'all',
              key: '0-0',
              children: optionsTreeNode,
            },
          ])
        } else {
          setTreeHoliday([])
          setListHoliday([])
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onChangeEvent = async (e, type) => {
    if (type === 'company') {
      const companyID = e
      const dataFindCompanyMatch = dataTree.find((c) => c.id === companyID)
      const operationList = dataFindCompanyMatch?.children
      const dataOperation = operationList?.map((o) => {
        return {
          key: o.id,
          value: o.id,
          label: o.title,
          suboperList: o.children || null,
        }
      })
      setListOperSearch(dataOperation)
      setListSubSearch([])
      setListHoliday([])
      formHolidayExport.setFieldsValue({
        operation: null,
        sub_operation: null,
        holiday_list: [],
      })
      await fetchListHoliday({ company_id: companyID })
    }

    if (type === 'oper') {
      const operationID = e
      // console.log(operationID)
      if (operationID !== undefined) {
        const dataFindOperationMatch = listopersearch.find(
          (oper) => oper.value === operationID,
        )
        const subOperationList = dataFindOperationMatch.suboperList?.map((sub) => {
          return {
            key: sub.id,
            value: sub.id,
            label: sub.title,
          }
        })
        setListSubSearch(subOperationList)
      } else {
        setListSubSearch([])
      }

      formHolidayExport.setFieldsValue({ sub_operation: null, holiday_list: [] })
      // ############### section search
      const { company, operation } = formHolidayExport.getFieldsValue()
      const sendParams = {
        company_id: company,
        operation_id: operation,
      }
      if (operation === undefined) {
        delete sendParams.operation_id
      }
      await fetchListHoliday(sendParams)
    }

    if (type === 'suboper') {
      formHolidayExport.setFieldsValue({ holiday_list: [] })
      const { company, operation, sub_operation } = formHolidayExport.getFieldsValue()
      const sendParams = {
        company_id: company,
        operation_id: operation,
        suboperation_id: sub_operation,
      }
      // ############### section search
      if (sub_operation === undefined) {
        delete sendParams.suboperation_id
      }
      await fetchListHoliday(sendParams)
    }

    if (type === 'holiday') {
      const HolidayList = e
      if (HolidayList.length !== 0) {
        setUnlockBtnExport(false)
      } else {
        setUnlockBtnExport(true)
      }
    }
  }

  const onFinishExport = async (form) => {
    setIsLoading(true)

    const formValue = form
    const MatchValueNameHoliday = listHoliday.map((l) => {
      return l.title
    })
    const ultimateParams = {
      company_id: formValue.company,
      operation_id: formValue.operation,
      suboperation_id: formValue.sub_operation,
      name:
        formValue.holiday_list[0] !== 'all'
          ? formValue.holiday_list.join(',')
          : MatchValueNameHoliday.join(','),
    }
    if (formValue.operation === null || formValue.operation === undefined) {
      delete ultimateParams.operation_id
    }
    if (formValue.sub_operation === null || formValue.sub_operation === undefined) {
      delete ultimateParams.suboperation_id
    }

    try {
      await exportHolidayV2({
        params: ultimateParams,
        token: token,
      }).then(async (res) => {
        if (res.status === 200) {
          setVisible(false)
          setIsLoading(false)
          setUnlockBtnExport(true)
          await getFileSecurityFromApi({ url: res.data.path, token }).then((response) => {
            const href = window.URL.createObjectURL(response.data)
            const anchorElement = document.createElement('a')
            anchorElement.href = href
            anchorElement.download = res?.data?.filename || 'download'
            document.body.appendChild(anchorElement)
            anchorElement.click()
            document.body.removeChild(anchorElement)
            window.URL.revokeObjectURL(href)
          })
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Modal
      className="editmodal"
      title={<h2 className="Modaltitle">Export holiday detail</h2>}
      visible={visible}
      onOk={() => formHolidayExport.submit()}
      okText={'Export'}
      onCancel={() => setVisible(false)}
      okButtonProps={{
        loading: isLoading,
        disabled: unlockBtnExport,
        style: { display: unlockBtnExport ? 'none' : '' },
      }}
    >
      <Form
        style={{ maxWidth: '472px' }}
        form={formHolidayExport}
        className="disable-page"
        layout="vertical"
        onFinish={onFinishExport}
      >
        <Form.Item
          label="Business Code"
          name="company"
          rules={[
            {
              required: true,
              message: 'Business code is require',
            },
          ]}
        >
          <Select
            disabled
            size="large"
            options={listcompanysearch}
            onChange={(e) => onChangeEvent(e, 'company')}
          />
        </Form.Item>
        <Form.Item label="Operation Code" name="operation">
          <Select
            allowClear
            size="large"
            options={listopersearch}
            onChange={(e) => onChangeEvent(e, 'oper')}
          />
        </Form.Item>
        <Form.Item label="Project type Code" name="sub_operation">
          <Select
            allowClear
            size="large"
            options={listsubsearch}
            onChange={(e) => onChangeEvent(e, 'suboper')}
          />
        </Form.Item>
        <Form.Item
          label="Holiday Name"
          name="holiday_list"
          rules={[
            {
              required: true,
              message: 'Holiday name is require',
            },
          ]}
        >
          <TreeSelect
            allowClear
            maxTagCount="responsive"
            treeDefaultExpandAll
            treeCheckable
            showCheckedStrategy={SHOW_PARENT}
            size="large"
            onChange={(e) => onChangeEvent(e, 'holiday')}
            treeData={treeHoliday}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default ExportHolidayModal
